var _stop, _stop2, _stop3, _stop4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgLocationSmall = function SvgLocationSmall(props) {
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#".concat(_id, ")"),
    strokeLinecap: "round",
    d: "M5.133 2.494A5.35 5.35 0 0 1 8 1.667c2.945 0 5.333 2.363 5.333 5.278 0 3.618-4.267 7.389-5.333 7.389-1.067 0-5.333-3.77-5.333-7.39 0-.927.241-1.799.666-2.556"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#".concat(_id2, ")"),
    strokeLinecap: "round",
    d: "M9.923 7.22A2.001 2.001 0 1 0 6 6.666a2 2 0 0 0 2.446 1.95"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 2.667,
    x2: 13.333,
    y1: 8,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 6,
    x2: 10,
    y1: 6.667,
    y2: 6.667,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  })))));
};
export default SvgLocationSmall;